import React from "react";
import { BaseDrawer } from "./base";

interface CandidatDrawerProps {
  candidat: any;
  onClose: () => void;
}

export function CandidatDrawer({ candidat, onClose }: CandidatDrawerProps) {
  return <BaseDrawer entity={candidat} entityType="candidat" onClose={onClose} />;
}
